import { graphql } from "@/lib/gql/__generated__";

export const HotelI18nUpdate_HotelInfoSettingsPage_Mutation = graphql(`
	mutation HotelI18nUpdate_HotelInfoSettingsPage($input: HotelI18nInput!) {
		hotelI18nUpdate(input: $input) {
			userErrors
			hotelI18n {
				id
				lang
				companyID
				hotelID
				name
				catchCopy
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
